export function insertTextAtSelection(
  currentText,
  insertedText,
  selectionStart,
  selectionEnd
) {
  const text = String(currentText ?? "");
  const insertion = String(insertedText ?? "");
  const start = Number.isInteger(selectionStart)
    ? Math.max(0, Math.min(selectionStart, text.length))
    : text.length;
  const end = Number.isInteger(selectionEnd)
    ? Math.max(start, Math.min(selectionEnd, text.length))
    : start;

  return (
    text.slice(0, start) +
    insertion +
    text.slice(end)
  );
}
